import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Menu } from 'src/app/digigov/models/menu.model';
import { AuthenticationService } from 'src/app/digigov/services/authentication.service';
import { DropdownCombo } from '../models/dropdownCombo.model';
import { EmployeeSearch } from '../models/employeeSearch.model';
import { SupportHistoryRes } from '../models/supportHistoryRes.model';
import { SupportReqRes } from '../models/supportReqRes.model';
import { UserDetail, UserDetailData } from '../models/userDetail.model';

@Injectable({
  providedIn: 'root',
})
export class SupportService {
  loggedInUserDetails: UserDetailData;
  constructor(
    private http: HttpClient,
    private authService: AuthenticationService
  ) {
    this.authService.loggedInUserSubject.subscribe((user: any) => {
      if (user) {
        this.loggedInUserDetails = user.employeeVO;
        this.getUserProfile();
      }
    });
  }

  getUserProfile(): void {
    this.http.get('/admin/my-profile').subscribe((res: any) => {
      this.loggedInUserDetails = { ...res?.data, ...this.loggedInUserDetails };
    });
  }
  //SUPPORT REQUEST
  raiseTicket(dataForPost): Observable<any> {
    return this.http.post(`/request/raise-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }
  screenshotUpload(
    formData: FormData
  ): Observable<{ data: [{ path: string }] }> {
    return this.http.post(`/dms/file-upload`, formData).pipe(
      map((res: { data: [{ path: string }] }) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //SUPPORT EXECUTIVE SCREEN
  getMenuData(): Observable<Menu[]> {
    const params = new HttpParams().append('previlageId', 589);
    return this.http
      .get('/access-control/user-privileges', {
        params: params,
      })
      .pipe(
        map((res: Menu[]) => res),
        catchError((error) => {
          throw error;
        })
      );
  }
  pullToWorklist(dataForPost: {
    refId: string[];
    applTypeId: number;
  }): Observable<any> {
    return this.http
      .post(`/workflow/pull-to-worklist-from-group`, dataForPost)
      .pipe(
        map((res) => res),
        catchError((error) => {
          throw error;
        })
      );
  }
  changeHierarchy(dataForPost): Observable<any> {
    return this.http.put(`/request/change-hierarchy`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }
  onEditSave(dataForPost): Observable<any> {
    return this.http.put(`/request/save-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //EXECUTIVE ACTION

  //ASSIGN
  getAssignLevel(dataForPost: {
    department: number;
    reqCat: number;
    reqType: number;
    reqsubType: number;
    pendingWithGroupId: number;
  }): Observable<any> {
    return this.http.post(`/request/assign-level`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }
  assignRequest(dataForPost): Observable<any> {
    return this.http.put(`/request/assign-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //In PROGRESS
  setInProgressRequest(dataForPost: {
    byEmpId: number;
    caseID: number;
    agentResolutionDtlVOs: {
      agentRemarks: any;
      attachString: any;
    }[];
  }): Observable<any> {
    return this.http.put(`/request/inProgress-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //ON HOLD
  setOnHoldRequest(dataForPost: {
    byEmpId: number;
    caseID: number;
    agentResolutionDtlVOs: {
      agentRemarks: any;
      attachString: any;
      externalTicket: any;
    }[];
  }): Observable<any> {
    return this.http.put(`/request/hold-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }
  //RESOLVE
  resolveRequest(dataForPost): Observable<any> {
    return this.http.put(`/request/resolve-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }
  //SEND BACK TO USER
  sendBackToUser(dataForPost): Observable<any> {
    return this.http.put(`/request/sendBack-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //USER ACTIONS

  //FEEDBACK
  feedback(dataForPost: {
    byEmpId: number;
    caseID: number;
    agentResolutionDtlVOs: {
      agentRemarks: any;
      attachString: string;
      feedbackRating: string;
    }[];
  }): Observable<any> {
    return this.http.put(`/request/close-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //RE OPEN
  reOpenRequest(dataForPost: {
    byEmpId: number;
    caseID: number;
    agentResolutionDtlVOs: {
      agentRemarks: any;
      attachString: string;
    }[];
  }): Observable<any> {
    return this.http.put(`/request/reopen-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //SEND BACK TO EXECUTIVE
  sendBackToExecutive(dataForPost: {
    byEmpId: number;
    caseID: number;
    agentResolutionDtlVOs: {
      agentRemarks: any;
      attachString: string;
    }[];
  }): Observable<any> {
    return this.http.put(`/request/resubmit-request`, dataForPost).pipe(
      map((res) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  //COMMON APIS
  getRequestDetails(dataForPost: {
    caseID?: number;
    caseNo?: string;
    openFrom: string;
  }): Observable<SupportReqRes> {
    return this.http.post(`/request/request-dtls`, dataForPost).pipe(
      map((res: SupportReqRes) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  getTimelineData(
    caseId: number,
    openFrom: string
  ): Observable<SupportHistoryRes> {
    const dataForPost = {
      caseId: caseId,
      openFrom: openFrom,
    };
    return this.http.post(`/request/request-history`, dataForPost).pipe(
      map((res: SupportHistoryRes) => res),
      catchError((error) => {
        throw error;
      })
    );
  }

  getEmployeeSearchDetails(
    empId: number | string
  ): Observable<EmployeeSearch | UserDetail> {
    return this.http.get(`/admin/employee-details/${empId}`).pipe(
      map((response: EmployeeSearch | UserDetail) => response),
      catchError((error) => {
        throw error;
      })
    );
  }
  getComboItems(
    mdmComboId: number | string,
    INITIATED_POST_ID?: number | string
  ): Observable<DropdownCombo> {
    const dataForPost = {
      // ACTIVE_FLAG: '1',
      // LOC_ID: '1',
      //LANG_ID: this.appInitService?.langId,
      ComboId: mdmComboId.toString(),
    };
    if (INITIATED_POST_ID) {
      dataForPost['INITIATED_POST_ID'] = INITIATED_POST_ID;
    }
    if (!dataForPost) throw new Error('dataForPost not found');
    return this.http.post(`/worklist/get-combo-list`, dataForPost).pipe(
      map((response: DropdownCombo) => response),
      catchError((error) => {
        throw error;
      })
    );
  }
}
